module.exports = __webpack_public_path__ + "img/2.8ede5f5e.png";